<mat-card style="box-shadow: none; padding: 0 !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <span mat-card-avatar>
            <mat-icon>schedule</mat-icon>
        </span>
        <mat-card-title>{{ data?.title || 'Report Delay' }}</mat-card-title>
    </mat-card-header>
    <mat-dialog-content>
        <p class="dialog-message">
            Choose the reason for delay.
        </p>
        <mat-form-field appearance="outline" class="reason-field">
            <mat-label>Delay reason</mat-label>
            <mat-select [(ngModel)]="selectedReasonCode">
                <mat-option *ngFor="let reason of data?.reasons" [value]="reason.id">
                    {{ reason.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button type="button" mat-button (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="confirm()" [disabled]="selectedReasonCode == null">
            Submit
        </button>
    </mat-dialog-actions>
</mat-card>
